export default __webpack_public_path__ + "static/media/postgresql.cfd8268b.png";